import React from 'react';
import PropTypes from 'prop-types';
import { ClipLoader } from 'react-spinners';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';

const SKY_BLUE = '#016089';

import './SpinnerNoInternet.scss';

const override = css`
  display: block;
  margin: 0 auto;
`;

const SpinnerNoInternet = (props) => {
  const { t } = useTranslation();
  return (
    <div className={`loading ${props.noHeight ? 'no-height' : ''}`}>
      <ClipLoader
        className={override}
        sizeUnit="px"
        size={props.spinnerSize}
        color={SKY_BLUE}
        speedMultiplier={props.speedMultiplier}
      />
      {!props.hideText && <p className="reconnecting">{t('common.labels.reconnecting')}</p>}
    </div>
  );
};

SpinnerNoInternet.propTypes = {
  noHeight: PropTypes.bool,
  spinnerSize: PropTypes.number,
  speedMultiplier: PropTypes.number,
  hideText: PropTypes.bool,
};

export default SpinnerNoInternet;
